import React from 'react';

function TimesheetList({ entries, onEdit, onDelete }) {
  if (!entries.length) {
    return <div className="text-gray-500 text-white">No timesheet entries available.</div>;
  }

  return (
    <div className="space-y-4">
      {entries.map((entry) => (
        <div
          key={entry._id}
          className="bg-white rounded-xl shadow p-4 border border-gray-200 flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
        >
          <div>
            <p className="text-lg font-medium">{entry.task}</p>
            <p className="text-gray-600 text-sm">Case: {entry.caseId?.caseTitle || 'N/A'}</p>
            <p className="text-gray-600 text-sm">Client: {entry.clientName}</p>
            <p className="text-gray-600 text-sm">Duration: {entry.duration} mins</p>
            <p className="text-gray-600 text-sm">Billable: {entry.billable ? 'Yes' : 'No'}</p>
            <p className="text-gray-600 text-sm">Notes: {entry.notes}</p>
            <p className="text-gray-500 text-xs">Status: {entry.caseId?.status || 'N/A'}</p>


          </div>

          <div className="flex gap-2 ml-auto">
            <button
              onClick={() => onEdit(entry)}
              className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
            >
              Edit
            </button>
            <button
              onClick={() => onDelete(entry._id)}
              className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
            >
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TimesheetList;
